import React from 'react'

function Footer() {
    return (
        <div id="footer">
        <span>Product by <a href='https://www.codifiedcoder.in' target='_blank'>Codified Coder</a></span>
       </div>
    )
}

export default Footer
